import { Stack } from '@mui/material'
import Drawer from '@mui/material/Drawer'
import { useQuery } from '@tanstack/react-query'
import { observer } from 'mobx-react'
import React, { FC } from 'react'
import { getImageSrc } from '../../../../helpers/getImageSrc'
import { isOperator } from '../../../../services/AccountService'
import { getActiveOrders } from '../../../../services/NewApiService'
import ServiceDrawerElement from '../Drawers/CreateServiceDrawer/ServiceDrawerElement'
import ServiceRequestDrawerElement from '../Drawers/CreateServiceDrawer/ServiceRequestDrawerElement'
import ContentTitle from './components/ContentTitle'
import DrawerHeader from './components/DrawerHeader'
import SuccessSearchResultButtons from './components/SuccessSearchResultButtons'
import { contentWrapperSx, searchResultTitleSx } from './consts/styles.consts'
import { createServiceRequestStore } from './stores/NewCreateServiceRequestStore'

interface NewSearchRequestSelectedResultsDrawerProps {}

const NewSearchRequestSelectedResultsDrawer: FC<
  NewSearchRequestSelectedResultsDrawerProps
> = ({}) => {
  const {
    isShowAllRequestsDrawerOpen,
    setIsShowAllRequestsDrawerOpen,
    setIsResultsDrawerOpen,
    setSearchParams,
    setSelectedRequest,
    setResetAll,
    selectedRequest,
    setActiveServiceOrder,
  } = createServiceRequestStore

  const { data: serviceRequest } = useQuery({
    queryKey: ['get-active-service-orders', selectedRequest?.orderId],
    queryFn: () => getActiveOrders(selectedRequest?.orderId ?? -1),
    enabled: () => !!isShowAllRequestsDrawerOpen,
  })

  const onBack = () => {
    setIsShowAllRequestsDrawerOpen(false)
    setIsResultsDrawerOpen(true)
    setSelectedRequest(null)
  }

  const onClose = () => {
    setIsShowAllRequestsDrawerOpen(false)
    setSelectedRequest(null)
    setSearchParams({})
    setActiveServiceOrder(null)
    setResetAll()
  }

  return (
    <Drawer
      anchor={'right'}
      open={isShowAllRequestsDrawerOpen}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: 380,
        },
      }}
    >
      <DrawerHeader
        title={`Заявка на ${!isOperator() ? 'обслуживание' : 'ремонт'}`}
        onBack={onBack}
        onClose={onClose}
      />
      <Stack
        sx={contentWrapperSx}
        spacing={'14px'}
        justifyContent={'space-between'}
      >
        <Stack spacing={'14px'} marginBottom={'40px !important'}>
          {selectedRequest && (
            <ServiceDrawerElement
              key={selectedRequest.id}
              el={selectedRequest}
              checkboxAction={() => {}}
              checkedServiceOrderId={selectedRequest?.orderId}
              openedAccordionIndex={0}
              setOpenedAccordionIndex={() => {}}
              index={0}
              serviceStore={{}}
              leftIcon={true}
              customOpen
            />
          )}
          <ContentTitle
            title={'Текущие обращения на обслуживание'}
            iconSrc={getImageSrc('search')}
            styles={{
              ...searchResultTitleSx,
              padding: '8px 16px',
              marginBottom: '4px !important',
            }}
            warn
          />
          {!!serviceRequest?.orders?.length && (
            <ServiceRequestDrawerElement
              el={serviceRequest.orders[0] ?? {}}
              customOpen={undefined}
              leftIcon={undefined}
            />
          )}
          {!serviceRequest?.orders?.length && (
            <Stack
              height={'49px'}
              justifyContent={'center'}
              alignItems={'center'}
              sx={{
                backgroundColor: 'rgba(246, 246, 246, 1)',
                borderBlock: '1px solid rgba(224, 223, 223, 1)',
                color: 'rgba(95, 95, 95, 1)',
                fontSize: '14px',
                fontFamily: "'PT Root UI'",
                fontWeight: 400,
                marginTop: '0 !important',
              }}
            >
              Активных обращений нет
            </Stack>
          )}
        </Stack>
        <Stack sx={{ paddingX: '16px' }} spacing={'14px'}>
          <SuccessSearchResultButtons
            onBack={onBack}
            createMode
            forbidCreating={!!serviceRequest?.orders?.length}
            onClose={onClose}
          />
        </Stack>
      </Stack>
    </Drawer>
  )
}

export default observer(NewSearchRequestSelectedResultsDrawer)
